import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { GlobalService } from 'app/global/global.service';
import { ReusableAttachmentService } from 'app/global/reusable-attachment.service';
import { Block } from 'app/interfaces/blocks';
import { SelectedFieldEnum } from 'app/interfaces/fields.dto';
import { Subject, Subscription } from 'rxjs';
import { FieldSettings } from '../../events/editor-emitter.dto';
import { EditorEmitterService } from '../../events/editor-emitter.service';
import { DocumentFieldService } from '../../settings/documentfields/documentfield.service';
import { MetaDataSectionEnum } from '../../settings/documentfields/meta-data.helper';
import { GeneralPopoverSettingsComponent } from '../general-popover-settings/general-popover-settings.component';
import { FieldTypes, SelectedRole } from '../general-popover-settings/general-popover-settings.dto';
import { UploadingOptions } from './attachment-settings.dto';
import { RecipientRole } from '../../edit-template/edit-template.dto';
import { EventHandlersService } from '../../edit-template/event-handler.service';
@Component({
  selector: 'app-attachment-settings',
  templateUrl: './attachment-settings.component.html',
  styleUrl: './attachment-settings.component.scss',
  providers: [GeneralPopoverSettingsComponent]
})
export class AttachmentSettingsComponent implements OnChanges, OnDestroy {

  @Input() data: FieldSettings;

  public request_from: number = 0;
  public SelectedFieldEnum = SelectedFieldEnum;
  public uploading_is: number = 1;
  public selectedAttachmentField: string = 'new';
  public uploadingOptions: Array<UploadingOptions> = [
    { id: 0, name: this._translocoService.translate("Attachment box settings Optional option (Template/Document - section) - Optional") },
    { id: 1, name: this._translocoService.translate("Attachment box settings Mandatory option (Template/Document - section) - Mandatory") },
  ];
  public attachmentData: Block;
  public role_id: number = 0;
  public keyword = 'name';
  public timeOutSubscription: Subscription;
  public fieldSectionEnum = MetaDataSectionEnum;
  public generalpopup: boolean = true;
  public fieldtype: Array<FieldTypes> = [];
  public destroy$ = new Subject<void>();
  constructor(
    private globalService: GlobalService,
    public generalPopoverSettings: GeneralPopoverSettingsComponent,
    private _translocoService: TranslocoService,
    private documentFieldService: DocumentFieldService,
    private reusableAttachmentService: ReusableAttachmentService,
    private _editorEmitter: EditorEmitterService,
    private eventHandlersService: EventHandlersService
  ) { }


  /**
   * detect the component changes
   * @param changes 
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.data = changes['data'].currentValue;
      this.updateSettings();

      if (this.attachmentData.type === "attachment") {
        this.setupAllFields();
      } else {
        this.generalpopup = false;
      }
    }
  }

  onSelectTypeChange($event){
    let attachmentLabel = $event?.name;
    if($event?.prefixid === 'new'){
      attachmentLabel = this._translocoService.translate("Content block html text on attachment (Template/Document - section) - attachment");
    }
    const attachmentData = {attachment_label: attachmentLabel, attachment_name: attachmentLabel, meta_data_name: attachmentLabel, meta_data_id: $event?.meta_data_id ?? 0, field_section: $event?.field_section ?? 'custom', role_id: Number($event?.role_id), is_uploaded: 0};
    this.attachmentData = {...this.attachmentData, ...attachmentData};
    this.globalService.updateBlock(this.data['uuid'], attachmentData);
    document.querySelectorAll('[uuid="'+this.attachmentData.uuid+'"] .attachment-name').forEach((element:HTMLElement) => {
      element.innerText = $event.name;
    });
    if(this.attachmentData?.files && this.attachmentData.files.length > 0){
      this.reusableAttachmentService.deleteAttachmentByUuid(this.attachmentData.uuid);
    }
    this.updateAttachment();
  }

  renameLabel(event) {
    const label = event.target.value;
    document.querySelectorAll('[uuid="'+this.attachmentData.uuid+'"] .attachment-name').forEach((element:HTMLElement) => {
      element.innerText = label;
    });
    this.attachmentData = this.globalService.updateBlock(this.data['uuid'], {attachment_name: label, attachment_label: label});
  }

    async setupAllFields() {
      if(!this.attachmentData.attachment_label){
        this.attachmentData.attachment_label = this.attachmentData.attachment_name;
      }
      if(this.attachmentData?.role_id && this.attachmentData?.meta_data_id && this.attachmentData?.field_section !== 'custom'){
        this.selectedAttachmentField = `${this.attachmentData.meta_data_id}_${this.attachmentData.field_section}_${this.attachmentData.role_id}`;
      } else {
        this.selectedAttachmentField = 'new';
      }
      this.generalpopup = false;
      const allfields: FieldTypes[] = [
      {
        id: 0,
        name: this._translocoService.translate("Content new field (Template/Document - section) - Field name - New field"),
        value: '',
        field_type: this._translocoService.translate("Field setting new text (Template/Document - section) - New"),
        field_info: 'custom_field',
        prefixid: "new",
        field_section: "custom",
        role_id: `0`,
        meta_data_id: 0,
      }]

      for (let index = 0; index < this.globalService.roles.length; index++) {
        const role: RecipientRole = this.globalService.roles[index];
        const personImageFields = role.personfields.filter(f => f.metadata_type === 'image' && f.is_enable);
        for (let index = 0; index < personImageFields.length; index++) {
          const personfields = personImageFields[index];
          allfields.push({
            id: `${personfields.id}`,
            name: `${personfields.name}`,
            value: '',
            key: personfields.key,
            field_type: role.role_name,
            field_info: 'recipient_field',
            field_required: `${personfields.required}`,
            // prefixid: `${personfields.id == 0 ? personfields.name + role.role_name : personfields.id}`,
            prefixid: `${personfields.metadata_id}_person_field_${role.id}`,
            role_id: `${role.id}`,
            meta_data_id: personfields.metadata_id,
            role_data: role,
            field_section: "person_field",
            validation: personfields.validations ?? {},
            color: role.role_color,
            recipient_id: role.recipient_id,
            lock: personfields?.lock ?? 0
          });
        }

        const orgImageFields = role.orgfields.filter(f => f.metadata_type === 'image' && f.is_enable);
        for (let index = 0; index < orgImageFields.length; index++) {
          const personfields = orgImageFields[index];
          allfields.push({
            id: `${personfields.id}`,
            name: `${personfields.name}`,
            value: '',
            key: personfields.key,
            field_type: `${role.role_name} (${this._translocoService.translate("Field setting org (Template/Document - section) - Org")})`,
            field_info: 'recipient_field',
            field_required: `${personfields.required}`,
            prefixid: `${personfields.metadata_id}_org_field_${role.id}`,
            meta_data_id: personfields.metadata_id,
            role_id: `${role.id}`,
            role_data: role,
            field_section: "org_field",
            validation: personfields.validations ?? {},
            color: role.role_color,
            recipient_id: role.recipient_id,
            lock: personfields?.lock ?? 0
          });
        }

      }
      this.fieldtype = allfields;
    }
  
  /**
   * update the settings of currect attachment
   */
  async updateSettings() {
    this.attachmentData = {...this.globalService.fields_data['blocks'][this.data['uuid']]};
    await this.generalPopoverSettings.setupAllFields();
  }

  onChangeSearch(val: string) {
    document.querySelectorAll('[uuid="'+this.attachmentData?.uuid+'"] .attachment-name').forEach((element:HTMLElement) => {
      element.innerText = val;
    });
  }
  
  /**
   * assign the attach to the specific role
   * @param role 
   */
  onChangeRole(role:SelectedRole){
    this.attachmentData = {...this.globalService.fields_data['blocks'][this.data['uuid']]};
    if(this.attachmentData?.files?.length > 0 && this.attachmentData?.is_uploaded && Number(role.id) > 0){
      this.reusableAttachmentService.deleteAttachmentByUuid(this.attachmentData.uuid);
    } 
    this.attachmentData = this.globalService.updateBlock(this.data['uuid'], { request_from: role.id });
    document.querySelectorAll('[uuid="'+this.attachmentData?.uuid+'"] .attachment-name').forEach((element:HTMLElement) => {
      element?.closest('.content-box-row')?.setAttribute('hover-content',this.generateAttachmentHoverMessage());
    });
    this.updateAttachment();
  }

  toggleMultipleFiles(event){
    document.querySelector('[name="'+this.attachmentData?.uuid+'"]')?.toggleAttribute('multiple',event.target.checked);
  }

  /**
   * close the content table right menu
   */
  close() {
    this.eventHandlersService.triggerEditorSideMenu({}, 'DEFAULT');
  }

  uploadingIs(uploadingIs:UploadingOptions){
    document.querySelectorAll('[uuid="'+this.attachmentData?.uuid+'"] .attachment-name').forEach((element:HTMLElement) => {
      element.closest('.content-box-row').setAttribute('hover-content',this.generateAttachmentHoverMessage());
    });
    this.attachmentData = this.globalService.updateBlock(this.data['uuid'], { uploading_is: uploadingIs.id });
  }

  viewingIs(viewingIs:UploadingOptions){
    this.attachmentData = this.globalService.updateBlock(this.data['uuid'], { viewing_is: viewingIs.id });
  }

  /**
   * generate attachment hover message
   */
  generateAttachmentHoverMessage(){
    let roleName = '';
    if(this.attachmentData?.request_from == 0){
      roleName = this._translocoService.translate("Field setting sender text (Template/Document - section) - Sender");
    }else if(this.attachmentData?.request_from == -1){
      roleName = this._translocoService.translate("Field setting anyone (Template/Document - section) - Anyone");
    }else{
      const role:SelectedRole = this.generalPopoverSettings.selectRole.find((role:SelectedRole) => role.id == Number(this.attachmentData?.request_from));
      if(role){
        roleName = role.name;
      }
    }
    return this.attachmentData?.uploading_is == 1 ? this._translocoService.translate("Attahcment is required by tooltip (Template/Document - section) - This type is required by roleName", {
        type: this.data['type'] == 'attachment' ? this._translocoService.translate("Content attachment - (Template/Document - section) - Attachment").toLocaleLowerCase() : "PDF",
        roleName:roleName
      }) : this._translocoService.translate("Attachment settings Role can upload tooltip (Template/Document - section) - Role can upload", {
        roleName:roleName
      })
  }

  updateAttachment(){
    this.reusableAttachmentService.updateAttachment(this.attachmentData);
    this.attachmentData = {...this.globalService.fields_data['blocks'][this.data['uuid']]};
  }

  updateBlockJson(key: string){
    if (this.attachmentData && this.attachmentData[key] !== undefined) {
      this.globalService.updateBlock(this.data['uuid'], { [key]: this.attachmentData[key] });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
